import React, {useEffect, useState} from "react";
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import {notify} from "../components/toast";
import {ToastContainer} from "react-toastify";
import {MunshiMenu} from "../components/Menu";
import MfxInputPanel from "../components/Manufacturing/MfxInputPanel";
import {Calendar} from "primereact/calendar";
import {jDateToMySql} from "../utilities/ToMySqlDate";
import {FloatLabel} from "primereact/floatlabel";
import {Auths} from "../utilities/getAuthDep";
import {useSpinner} from "../context/SpinnerContext";


export const MfxInput = ({handle}) => {
    const {loading, setLoading} = useSpinner()
    const [itemList, setItemList] = useState([]);
    const [mfxList, setMfxList] = useState([]);
    const [companyName, setCompanyName] = useState("");
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    const [selectedDate, setSelectedDate] = useState(new Date());


    useEffect(() => {

        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') || "Test");
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`biodata/`,).then((response) => {
            setCompanyName(response.data.name)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, []);
    useEffect(() => {
        setLoading(true)

        const sqlDate = jDateToMySql(selectedDate)

        axiosInstance.get(`/mfx/mode/${sqlDate}&INPT`).then((response) => {
            if (response.data.length === 0) {
                const newMfx = {
                    id: "0001",
                    date: sqlDate,
                    status: "INPT",
                    itemName: "",
                    itemId: 0,
                    quantity: 0,

                }
                setMfxList([newMfx])

            } else {
                setMfxList(response.data)
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [selectedDate])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get('/item/basic/').then((response) => {
            setItemList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])
    const saveMfx = (data) => {
        setLoading(true)

        if (data.length === 1 && data[0].itemName === "" && data[0].quantity === 0) {
            axiosInstance.delete(`/mfx/mode/${jDateToMySql(selectedDate)}&INPT`).then((response) => {
                notify("Data deleted", "success")
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                setLoading(false)
            )
            return;

        }
        let _data = data.filter((item) => item.itemName !== "")
        if (_data.length > 0) {
            _data = _data.map(it => {
                if (it.itemName === "") {
                    return {
                        ...it,
                        itemId: itemList.find(item => item.name.trim() === it.itemName.trim()).id,
                        status: "INPT",
                        id: 0
                    }
                }
            })
            axiosInstance.post(`/mfx/`, _data
            ).then((response) => {
                setMfxList(data)
                notify(response.data, "success")
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                setLoading(false)
            )
        } else {
            notify("No Data", "warning")
        }
    }

    const MfxSelect = () => {
        if (mfxList && itemList && !loading) {
            return (
                <>
                    <MfxInputPanel mfxList={mfxList} saveMfx={(data) => saveMfx(data)}
                                   selectedDate={jDateToMySql(selectedDate)}
                                   itemList={itemList.map((item) => {
                                       return {
                                           id: item.id,
                                           name: item.name,

                                       }
                                   })}
                    />
                </>

            )
        } else {
            return null
        }
    }


    if (!loading && itemList && mfxList && itemList.length > 0) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                <div
                    className="flex flex-row container  h-auto w-full pd-10 mt-7 mb-2 justify-content-center align-content-center">
                    <FloatLabel>
                        <Calendar style={{fontSize: '10px'}} id="buttondisplay" dateFormat="dd/mm/yy"
                                  className="h-2rem pr-2 mr-2"
                                  value={selectedDate} onChange={(e) => setSelectedDate(e.value)}
                                  selectionMode={"single"}/>
                        <label htmlFor="buttondisplay">Date</label>
                    </FloatLabel>
                </div>
                <div className="  w-full h-full m-2 ">
                    <MfxSelect/>
                </div>

            </>
        );
    }

}
